import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';

export function getOrganizationForm() {
    return new FormGroup({
        id: new FormControl(),
        identifier: new FormArray([new FormGroup({
            value: new FormControl('')
        })]),
        name: new FormControl('', Validators.compose([Validators.required])),
        active: new FormControl(true),
        telecom: new FormArray([]),
        address: new FormArray([]),
        contact: new FormArray([]),
    });
}
